import React, { Component } from 'react';
import Modal from 'react-bootstrap4-modal';
import { inject } from 'mobx-react';
import { connectionGet, connectionPost, connectionDelete } from '../utils/connection';
import { Spinner } from 'reactstrap';

// Account-focused profile manager. Given an account, shows every profile it's
// assigned to (with unassign), lets you assign it to a new profile, and lets you
// remove it from all profiles at once (the account itself stays active).
@inject('userStore')
class AccountProfiles extends Component {
  constructor(props){
    super(props);
    this.state = {
      loading:false,
      assignment_list:[],
      available_profile_list:[],
      sys_role_list:[],
      profileSearch:'',
      form:{profile_id:'', sys_role_id:3, is_email:1}
    };
  }

  componentDidUpdate(prevProps){
    const becameVisible = this.props.visible && !prevProps.visible;
    const acctChanged = this.props.visible && this.props.account && prevProps.account &&
      this.props.account.hash_id !== prevProps.account.hash_id;
    if ((becameVisible || acctChanged) && this.props.account){
      this.fetch();
    }
  }

  fetch = () => {
    this.setState({loading:true}, () => {
      connectionGet('v2/accounts/' + this.props.account.hash_id + '/profiles', {}, {username: this.props.userStore.token})
      .then((res) => {
        if (res.data.errors === 0){
          this.setState({
            loading:false,
            assignment_list:res.data.assignment_list || [],
            available_profile_list:res.data.available_profile_list || [],
            sys_role_list:res.data.sys_role_list || [],
            profileSearch:'',
            form:{profile_id:'', sys_role_id:3, is_email:1}
          });
        } else {
          this.setState({loading:false});
        }
      }).catch((error) => { console.log(error); this.setState({loading:false}); });
    });
  }

  notifyParent = () => { if (this.props.onChange) this.props.onChange(); }

  handleFormChange = (e) => {
    const f = Object.assign({}, this.state.form);
    if (e.target.name === 'is_email'){
      f.is_email = e.target.checked ? 1 : 0;
    } else {
      f[e.target.name] = e.target.value;
    }
    this.setState({form:f});
  }

  assign = () => {
    const {form} = this.state;
    if (!form.profile_id) return;
    connectionPost('v2/accounts/' + this.props.account.hash_id + '/profiles',
      {profile:{profile_id:form.profile_id, sys_role_id:form.sys_role_id, is_email:form.is_email}},
      {username: this.props.userStore.token})
    .then((res) => {
      if (res.data.errors === 0){ this.fetch(); this.notifyParent(); }
      else { alert(res.data.message); }
    }).catch((error) => { console.log(error); });
  }

  unassign = (map_id) => {
    connectionDelete('v2/accounts/' + this.props.account.hash_id + '/profiles',
      {params:{id:map_id}, auth:{username: this.props.userStore.token}})
    .then((res) => {
      if (res.data.errors === 0){ this.fetch(); this.notifyParent(); }
      else { alert(res.data.message); }
    }).catch((error) => { console.log(error); });
  }

  removeAll = () => {
    if (!window.confirm('Remove this account from ALL profiles? The account stays active but loses access to every restaurant.')) return;
    connectionDelete('v2/accounts/' + this.props.account.hash_id + '/profiles',
      {params:{all:1}, auth:{username: this.props.userStore.token}})
    .then((res) => {
      if (res.data.errors === 0){ this.fetch(); this.notifyParent(); }
      else { alert(res.data.message); }
    }).catch((error) => { console.log(error); });
  }

  render(){
    const {account, visible, onClose} = this.props;
    const {loading, assignment_list, available_profile_list, sys_role_list, profileSearch, form} = this.state;
    if (!account) return null;
    const search = (profileSearch || '').toLowerCase();
    const filtered = (available_profile_list || []).filter(p => !search || (p.name || '').toLowerCase().indexOf(search) > -1);
    return (
      <Modal visible={visible} onClickBackdrop={onClose} dialogClassName="modal-lg">
        <div className="modal-header">
          <h4 className="modal-title">Profiles for {account.account_name} <small className="text-muted">{account.email}</small></h4>
          <button type="button" className="close" onClick={onClose} aria-label="Close"><span aria-hidden="true">&times;</span></button>
        </div>
        <div className="modal-body">
          {loading ?
            <h4><Spinner color="primary"/> Loading...</h4>
          :
          <React.Fragment>
            <h5>Currently assigned ({assignment_list.length})</h5>
            <table className="table table-condensed table-bordered">
              <thead>
                <tr><th>Profile</th><th>Role</th><th>Weekly Email</th><th>Status</th><th>Action</th></tr>
              </thead>
              <tbody>
                {assignment_list.length === 0 ?
                  <tr><td colSpan="5"><em>Not assigned to any profiles.</em></td></tr>
                :
                  assignment_list.map((a, i) => (
                    <tr key={i}>
                      <td>{a.profile_name}</td>
                      <td><span className="badge badge-default">{a.sys_role}</span></td>
                      <td>{parseInt(a.is_email) === 1 ? <span className="badge badge-success">Yes</span> : <span className="badge badge-danger">No</span>}</td>
                      <td>{parseInt(a.sys_status_id) === 1 ? <span className="badge badge-success">ACTIVE</span> : <span className="badge badge-danger">INACTIVE</span>}</td>
                      <td><button className="btn btn-sm btn-danger" onClick={() => this.unassign(a.id)}>Unassign</button></td>
                    </tr>
                  ))
                }
              </tbody>
            </table>

            <h5 className="m-t-20">Assign to a profile</h5>
            <div className="row">
              <div className="col-md-5">
                <div className="form-group form-group-default">
                  <label>Find Profile</label>
                  <input type="text" className="form-control" placeholder="restaurant name" value={profileSearch} onChange={(e) => this.setState({profileSearch:e.target.value})}/>
                </div>
                <div className="form-group form-group-default">
                  <label>Profile</label>
                  <select className="form-control" name="profile_id" value={form.profile_id} onChange={this.handleFormChange}>
                    <option value="">Select Profile ({filtered.length})</option>
                    {filtered.map((p, i) => <option key={i} value={p.id}>{p.name}</option>)}
                  </select>
                </div>
              </div>
              <div className="col-md-5">
                <div className="form-group form-group-default">
                  <label>Role</label>
                  {sys_role_list.map((r, i) => (
                    <div key={i} className="form-check primary">
                      <input type="radio" name="sys_role_id" id={'apr_' + i} value={r.id} checked={parseInt(form.sys_role_id) === r.id} onChange={this.handleFormChange}/>
                      <label htmlFor={'apr_' + i}>{r.name}</label>
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group form-group-default">
                  <div className="form-check primary">
                    <input type="checkbox" name="is_email" id="apr_email" checked={parseInt(form.is_email) === 1} onChange={this.handleFormChange}/>
                    <label htmlFor="apr_email">Weekly Email</label>
                  </div>
                </div>
              </div>
            </div>
            <button className={form.profile_id ? "btn btn-primary" : "btn btn-primary disabled"} disabled={!form.profile_id} onClick={this.assign}>Assign</button>
          </React.Fragment>
          }
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-danger pull-left mr-auto" onClick={this.removeAll} disabled={loading || assignment_list.length === 0}>Remove from all profiles</button>
          <button type="button" className="btn btn-secondary" onClick={onClose}>Close</button>
        </div>
      </Modal>
    );
  }
}

export default AccountProfiles;
